// src/modules/documentacion/routes/DocumentacionRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import DocumentacionPage from "../pages/DocumentacionPage";
import GuiaPlataformasPage from "../pages/GuiaPlataformasPage";

const DocumentacionRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<DocumentacionPage />} />
      <Route path="plataformas-de-rastreo" element={<GuiaPlataformasPage />} />
    </Routes>
  );
};

export default DocumentacionRoutes;
